module.exports = __webpack_public_path__ + "img/perfil_sway-back.2461f80b.jpg";